/**
 * Carousel - H5 版本
 * 使用 zarm Carousel
 */
import React from 'react';
import { Carousel as ZarmCarousel } from 'zarm-v3';

export interface CarouselProps {
  autoPlay?: boolean;
  loop?: boolean;
  children: React.ReactNode;
  className?: string;
  dotsClassName?: string;
}

export const Carousel: React.FC<CarouselProps> = ({
  autoPlay = true,
  loop = true,
  children,
  className,
  dotsClassName: _dotsClassName,
}) => (
  <ZarmCarousel className={className} autoPlay={autoPlay} loop={loop}>
    {children}
  </ZarmCarousel>
);

export default Carousel;
